import { render, staticRenderFns } from "./proforma-print.vue?vue&type=template&id=6c2af779&scoped=true"
import script from "./proforma-print.vue?vue&type=script&lang=js"
export * from "./proforma-print.vue?vue&type=script&lang=js"
import style0 from "./proforma-print.vue?vue&type=style&index=0&id=6c2af779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2af779",
  null
  
)

export default component.exports